<style>

  .MyListMenu li{
    list-style: none;
    cursor: pointer;
    border-left: 2px dotted rgb(60, 58, 58);
  }
  .MyListMenu li:hover  i{
    visibility: visible !important;
  }
  .MyListMenu li:hover p{
    text-decoration: underline;
    font-style: italic;
    font-weight: bold;
  }
  .Lvl2{
    margin: 10px 20px;
  }
</style>
<div [hidden]="Switcher_View!='Table'" class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">System Menu Help</h5>

      <div style="margin: 50px;">

        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> Menu Type </label>
            <select (change)="OnChangeMeneType()" [(ngModel)]="Filter_MenuType" class="custom-select">
              <option value="0">Behfa Menus</option>
              <option value="1">Farakhadamat Menus</option>
            </select>
          </div>
        </div>

        <ng-container *ngFor="let lvl1 of Data_List_Menu">
          <ul class="MyListMenu">
              <b>{{lvl1.title}}</b>
              <li *ngFor="let item of lvl1.child" (click)="set_Nav(item)">
                <p [ngClass]="{'Lvl2':item.parent>0}">{{item.title}}
                  <i title="View Form" style="color: green;cursor: pointer;visibility: hidden;" class="fa fa-plus-circle"></i>
                </p>
              </li>
            </ul>
          </ng-container>

      </div>

  </div>
</div>



<app-HelpForm  (OnBack_Help_Action)="set_Form($event)" [inner_Nav]="Select_Record_Nav" *ngIf="Switcher_View=='Form'">

</app-HelpForm>
